module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.barStatus > 0) ? _c('v-flex', {
    staticClass: "sm12"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "color": _vm.barStatus === 1 ? 'orange' : _vm.barStatus === 2 ? 'green' : 'red',
      "dark": ""
    }
  }, [(_vm.barStatus >= 2) ? _c('span', [_vm._v(" " + _vm._s(_vm.barStatusText) + " ")]) : _vm._e(), _vm._v(" "), (_vm.barStatus === 1) ? _c('span', [_vm._v("\n            TEST VECTOR\n            "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onTestFileChange
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.barStatus === 1 && _vm.getMemoryInstanceArray().length > 0) ? _c('span', [_vm._v("\n            MEMORY CONTENTS\n            "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onMemFileChange
    }
  })]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', [_c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "top": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": _vm.onBarButtonClick
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.barStatus === 0 ? 'keyboard_arrow_down' : 'keyboard_arrow_up'))])], 1), _vm._v(" "), (_vm.otherGroups.length > 0) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "small": "",
      "color": "yellow",
      "bottom": "",
      "left": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.showOthers = !_vm.showOthers
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showOthers ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.parameterGroups), function(signalGroup) {
    return [_c('v-list-tile', [_c('v-list-tile-action', [(signalGroup.isInput || signalGroup.isOutput) ? _c('v-icon', {
      attrs: {
        "color": _vm.inputOutputIconColor(signalGroup)
      },
      on: {
        "click": function($event) {
          _vm.clear(signalGroup)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.inputOutputIcon(signalGroup)) + "\n                     ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v(_vm._s(signalGroup.name))]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_vm._l((signalGroup.equipotentialIndexes), function(index) {
      return [_c('v-icon', {
        attrs: {
          "disabled": !signalGroup.isInput
        },
        on: {
          "click": function($event) {
            _vm.onIconClick(index)
          }
        }
      }, [_vm._v(_vm._s(_vm.checkIcon(index, signalGroup.isInput)))])]
    })], 2)])], 1)]
  })], 2)], 1), _vm._v(" "), (_vm.showOthers) ? _c('v-card', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.otherGroups), function(signalGroup) {
    return [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon')], 1), _vm._v(" "), _c('v-list-tile-content', [_vm._v(_vm._s(signalGroup.name))]), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_vm._l((signalGroup.equipotentialIndexes), function(index) {
      return [_c('v-icon', {
        attrs: {
          "disabled": true
        }
      }, [_vm._v(_vm._s(_vm.checkIcon(index, false)))])]
    })], 2)])], 1)]
  })], 2) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bef874d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shdl/ShdlSimulator.vue
// module id = 1205
// module chunks = 1